import React from 'react';
// eslint-disable-next-line no-restricted-imports
import { Accordion as DSAccordion } from '@hvcgroep/design-system';
import { APP_ID } from '../../config/constants';
import gtm from '../../helpers/gtm';

type BaseAccordionProps = React.ComponentProps<typeof DSAccordion>;

interface Props extends BaseAccordionProps {
  noTracking?: boolean;
}

const Accordion: React.FC<Props> = (props) => {
  const {
    title,
    onOpen,
    children,
    noTracking,
  } = props;

  const openFunction = () => {
    if (!noTracking) {
      gtm.trackUserEvent(String(APP_ID), 'Open Accordion', title);
    }

    if (onOpen) {
      onOpen();
    }
  };

  return (
    <DSAccordion
      {...props}
      onOpen={openFunction}
    >
      {children}
    </DSAccordion>
  );
};

export default Accordion;
